<template>
  <div class="flex-1 flex flex-col overflow-hidden">
    <Header :title="t.page_name" @childLang="useLang" />
    <main class="flex-1 overflow-x-hidden overflow-y-auto" style="background: var(--ice);">
      <div class="d2-home-content onboarding-link-content">
        <div class="d2-card onboarding-link-card">
          <div class="d2-card-title">
            <i class="fas fa-link"></i>{{ t.page_name }}
          </div>
          <p class="onboarding-link-lead">{{ t.lead }}</p>

          <div class="onboarding-link-steps">
            <div class="onboarding-link-step">
              <span>1</span>
              <div>
                <strong>{{ t.step_login_title }}</strong>
                <p>{{ t.step_login_desc }}</p>
              </div>
            </div>
            <div class="onboarding-link-step">
              <span>2</span>
              <div>
                <strong>{{ t.step_adaccount_title }}</strong>
                <p>{{ t.step_adaccount_desc }}</p>
              </div>
            </div>
            <div class="onboarding-link-step">
              <span>3</span>
              <div>
                <strong>{{ t.step_page_title }}</strong>
                <p>{{ t.step_page_desc }}</p>
              </div>
            </div>
          </div>

          <div class="onboarding-link-box">
            <LinkAccount
              v-bind:lang="showLang[selectLang]"
              v-bind:tiktokLang="showTiktokLang[selectLang]"
              v-bind:firstLoginStatue="firstLoginStatue"
              v-bind:transmitFbNum="transmitFbNum"
              v-bind:transmitTiktokNum="transmitTiktokNum"
              v-bind:user_info="user_info"
              :guideStep="nowStep"
              :hideTeachingButton="true"
              @nextStep="nextStep"
              @childChangeLinkType="setChangeLinkType"
              @adaccountLength="updateAdaccount"
              @pageLength="updatePage"
              @connectedAdaccountLength="updateConnectedAdaccount"
              @connectedPageLength="updateConnectedPage"
              @childLinkAccount="handleLinkAccountFinish"
              @childActive="childActive"
            />
          </div>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import LinkAccount from '@/components/LinkAccount/Index.vue'
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import axios from 'axios'
import Qs from 'qs'
import lang from '@/language/lang.json'
import tiktokLang from '@/language/tiktok_lang.json'
import { API_BASE_URL } from '@/api/config'

export default {
  name: 'OnboardingLinkAccount',
  components: {
    Header,
    LinkAccount
  },
  data() {
    return {
      selectLang: 'zh-TW',
      showLang: lang,
      showTiktokLang: tiktokLang,
      firstLoginStatue: 'N',
      transmitFbNum: null,
      transmitTiktokNum: null,
      user_info: {
        user_id: null,
        tiktok_user_id: null
      },
      nowStep: -1,
      adaccountData: 0,
      pageData: 0,
      connectedAdaccountData: 0,
      connectedPageData: 0,
      activeType: 0,
      dashboardRedirected: false
    }
  },
  computed: {
    t() {
      return this.showLang[this.selectLang]['views']['OnboardingLinkAccount']
    },
    canEnterDashboard() {
      return Number(this.connectedAdaccountData) > 0 && Number(this.connectedPageData) > 0
    }
  },
  created() {
    this.init()
  },
  methods: {
    useLang(value) {
      this.selectLang = value
    },
    async init() {
      try {
        const langResponse = await axios.post(`${API_BASE_URL}/get_lang.php`, Qs.stringify({
          s_code: this.$route.params.id
        }))
        if (langResponse.data.status === 'success') {
          this.selectLang = langResponse.data.return_data
        }

        const loginResponse = await axios.post(`${API_BASE_URL}/login.php`, Qs.stringify({
          s_code: this.$route.params.id,
          type: this.$route.params.type
        }), { withCredentials: true })

        if (loginResponse.data.status === 'success') {
          this.user_info = {
            user_id: loginResponse.data.user_id,
            tiktok_user_id: loginResponse.data.tiktok_user_id
          }
          return
        }

        Swal.fire(this.t.login_error_title, loginResponse.data.info || this.t.login_error_text, 'error')
      } catch (error) {
        Swal.fire(this.t.login_error_title, this.t.login_error_text, 'error')
      }
    },
    nextStep() {},
    setChangeLinkType(value) {
      this.$emit('childSetChangeLinkType', value)
    },
    updateAdaccount(value) {
      this.adaccountData = value
    },
    updatePage(value) {
      this.pageData = value
    },
    updateConnectedAdaccount(value) {
      this.connectedAdaccountData = value
    },
    updateConnectedPage(value) {
      this.connectedPageData = value
      if (Number(value) > 0) {
        this.goDashboard()
      }
    },
    handleLinkAccountFinish(value) {
      const parts = String(value || '').split('_')
      if (parts[0] !== 'true') {
        return
      }

      this.connectedAdaccountData = Math.max(Number(this.connectedAdaccountData), 1)
      this.connectedPageData = Math.max(Number(this.connectedPageData), Number(parts[2]) || 1)
      this.goDashboard()
    },
    childActive(value) {
      this.activeType = value
    },
    goDashboard() {
      if (this.dashboardRedirected) {
        return
      }
      this.dashboardRedirected = true
      window.location.href = `/events-list/${this.$route.params.type}/${this.$route.params.id}`
    }
  }
}
</script>

<style lang="scss" scoped>
.onboarding-link-card {
  width: 100%;
  max-width: 1080px;
  margin: 0;
}

.onboarding-link-content {
  width: 100%;
  min-height: calc(100vh - 96px);
  display: flex;
  align-items: center;
  justify-content: center;
}

.onboarding-link-lead {
  margin: 8px 0 18px;
  color: var(--slate);
  line-height: 1.7;
}

.onboarding-link-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 18px;
}

.onboarding-link-step {
  display: flex;
  gap: 12px;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  padding: 14px;
  background: #fff;
}

.onboarding-link-step span {
  width: 28px;
  height: 28px;
  flex: 0 0 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--d2-blue, #2563ea);
  color: #fff;
  font-weight: 700;
}

.onboarding-link-step strong {
  display: block;
  color: var(--black);
  font-size: 14px;
}

.onboarding-link-step p {
  margin: 4px 0 0;
  color: var(--slate);
  font-size: 13px;
  line-height: 1.6;
}

.onboarding-link-box {
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 8px;
  padding: 16px;
  background: #f8fafc;
}

@media (max-width: 900px) {
  .onboarding-link-content {
    min-height: auto;
    align-items: flex-start;
  }

  .onboarding-link-steps {
    grid-template-columns: 1fr;
  }

}
</style>
